export default "__VITE_ASSET__CI4SrWkt__"